// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"SI-z"};